import * as React from "react";
import {
  ViewContext,
} from 'components/lib';
import { Controller } from "react-hook-form";
import { Label } from "../../../../components/ui/label";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  SelectLabel,
  SelectGroup,
} from "../../../../components/ui/select";
import { FieldError } from "../FieldError";
import { useWatch } from "react-hook-form";

const YES_NO = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export function HasInsuredOperatedUnderDotNum({ control, setValue }) {
  const carrier = useWatch({ control, name: "step1.carrier" });

  return (
    <>
      {carrier?.includes('Progressive') && <div className="space-y-2">
        <Label>
          Was the insured's DOT # issued within the last 60 days?
        </Label>
        <Controller
          control={control}
          name="step2.insuredIssuedWithInLastSixtyDays"
          render={({ field }) => (
            <Select
              value={field.value === "na" ? "" : (field.value ?? "")}
              onValueChange={(v) => {
                field.onChange(v);
              }}
              onOpenChange={() => {
                field.onChange(field.value ?? "");
              }}
            >
              <SelectTrigger
                className={"w-full"}
              >
                <SelectValue placeholder="Select" />
              </SelectTrigger>
              <SelectContent className="max-h-60 overflow-y-auto">
                <SelectGroup>
                  <SelectLabel>Choose</SelectLabel>
                  {YES_NO.map((opt) => (
                    <SelectItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          )}
        />
        <FieldError
          name="step2.insuredIssuedWithInLastSixtyDays"
          step="step2"
          control={control}
        />
      </div>}
    </>
  );
}
